export var DemoExtensionStatus = /*#__PURE__*/function (DemoExtensionStatus) {
  DemoExtensionStatus["Granted"] = "Granted";
  DemoExtensionStatus["Pending"] = "Pending";
  DemoExtensionStatus["Rejected"] = "Rejected";
  return DemoExtensionStatus;
}(DemoExtensionStatus || {});
export function readableDemoExtensionStatus(status) {
  if (status === DemoExtensionStatus.Pending) return "Verlängerung beantragt";
  if (status === DemoExtensionStatus.Rejected) return "Verlängerung abgelehnt";
  return "";
}